import { render, staticRenderFns } from "./BenefitNotificationBox2.vue?vue&type=template&id=321703e6"
import script from "./BenefitNotificationBox2.vue?vue&type=script&lang=js"
export * from "./BenefitNotificationBox2.vue?vue&type=script&lang=js"
import style0 from "./BenefitNotificationBox2.vue?vue&type=style&index=0&id=321703e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports